<template>
    <div class="app-article">
        <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>

        <div class="container">
            <div class="row my-5">

                <!-- Breadcrumb -->
                <div class="col-md-12 col-lg-10 offset-lg-1 mb-3" v-if="contentLoaded">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/articles">News & Articles</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: #A8C7D1;">{{ articleData.title }}</li>
                        </ol>
                    </nav>
                </div>

                <!-- Content -->
                <div class="col-md-12 col-lg-10 offset-lg-1">
                    
                    <div v-if="isError404 == false">
                        <div v-if="contentLoaded">
                            <div class="article-excerpt-image mb-5" v-if="articleData.img">
                                <img :src="articleData.excerpt_image" alt="">
                            </div>

                            <div class="article-title mb-4">
                                <h2 class="header-text primary-color">
                                    {{ articleData.title }}
                                    <small class="secondary-color d-block" style="font-family: 'Adobe Clean'">
                                        Posted on {{ articleData.date_created }} by {{ articleData.created_by }}
                                    </small>
                                </h2>
                            </div>

                            <div class="artticle-content">
                                <p v-html="articleData.content"></p>
                            </div>

                            <hr>

                            <div class="d-flex justify-content-between">
                                <router-link :to="`/articles/${articleData.previous_article.date_link}/${articleData.previous_article.dash}/${articleData.previous_article.mask}`" 
                                    v-if="articleData.pr_status"
                                >
                                    <i class="ti-arrow-left"></i> Previous Article 
                                </router-link>

                                <router-link :to="`/articles/${articleData.next_article.date_link}/${articleData.next_article.dash}/${articleData.next_article.mask}`" 
                                    v-if="articleData.nt_status"
                                >
                                    Next Article <i class="ti-arrow-right"></i>
                                </router-link>
                            </div>

                        </div>

                        <div v-if="!contentLoaded">
                            <fake-article></fake-article>
                        </div>
                    </div>

                    <div v-if="isError404 == true">
                        <error-404></error-404>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let heroImage = require('@/assets/img/hero/news.jpg');

import TopHero from '@/components/frontend/Hero.vue';
import Error404 from '@/components/Error404.vue';
import FakeArticle from '@/components/frontend/content_placeholders/Article.vue';
import axios from 'axios';

export default {
    components: {
        TopHero: TopHero,
        FakeArticle: FakeArticle,
        Error404: Error404
    },
    name: 'Article',
    data() {
        return {
            articleData: {},
            contentLoaded: false,
            isError404: null,
            heroImage: heroImage,
            title: null
        };
    },
    metaInfo() {
        return {
            title: this.articleData.title ? this.articleData.title : 'Error 404'
        };
    },
    methods: {
        fetchArticleData() {
            let dash = this.$route.params.articledash;
            let mask = this.$route.params.articlemask;
            let date = this.$route.params.articledate;

            if (!dash && !mask && !date) {
                this.isError404 = true;
                return false;
            }
            axios
                .get(APIURL + `articles/${mask}/${dash}`)
                .then(response => {
                    let res = response.data;
                    if (res.status == 200) {
                        this.title = res.data.title;
                        this.contentLoaded = true;
                        this.isError404 = false;
                        this.articleData = res.data;
                    } else {
                        this.isError404 = true;
                        this.title = 'Error 404';
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    created() {
        this.fetchArticleData();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/frontend/article/article.vue